import { render, staticRenderFns } from "./SolarRoof2.vue?vue&type=template&id=c1753432&"
import script from "./SolarRoof2.vue?vue&type=script&lang=js&"
export * from "./SolarRoof2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports